<template>
  <div>
    <EmptyCardModal
      v-if="modalChangeQtyData"
      :modalData="modalChangeQtyData"
      :onModalClose="(reset) => modalChangeQtyData = null"
      :onModalAccept="updateChangeQty"
    >
      <slot>
        <template v-if="modalChangeQtyData.type === 'changeQty'">
          <ChangeQtyBlock
            ref="changeBlock"
            :hideRemain="true"
            :drug="modalChangeQtyData.drug"
          />
        </template>
        <template v-else>
          <div v-for="comment in modalChangeQtyData.detail.comments" class="comment">
            <p>{{ comment.text }}</p>
            <p class="text-muted text-right" v-if="comment.date">{{ printDate(comment.date) }} <span
              v-if="comment.user_name">({{ comment.user_name }})</span></p>
          </div>
        </template>
      </slot>
    </EmptyCardModal>
    <table class="table table-sm table-hover">
      <thead>
      <tr>
        <th>#</th>
        <th></th>
        <th v-if="!hideEditDetails"></th>
        <th v-if="drugsImages"></th>
        <th>Препарат</th>
        <th>Комментарий</th>
        <th width="100">Сверка</th>
        <th width="175">Количество</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(detail, i) in getSortedDetails()"
          v-bind:class="{mark: false && detail.comments && detail.comments.length}">
        <td>{{ i + 1 }}</td>
        <td>
          <template v-if="detail.drug.cool">
            <i class="icon icon-snowflake"/>
          </template>
        </td>
        <td v-if="!hideEditDetails">
          <template v-if="detail.comments">
            <button @click="openCommentBlock(detail)" class="btn btn-default comments_btn" type="button">
              <i class="icon-fa icon-fa-comments-o text-center"/>
              <span v-if="detail.comments && detail.comments.length"
                    class="badge badge-info">{{ detail.comments.length }}</span>
            </button>
          </template>
        </td>
        <td v-if="drugsImages">
          <v-popover
            v-if="drugsImages[detail.drug_id]"
            class="d-inline"
            placement="bottom"
            :auto-hide="true"
          >
            <i class="icon-fa icon-fa-photo pointer mr-1"></i>
            <template slot="popover">
              <img :src="drugsImages[detail.drug_id]" alt="">
            </template>
          </v-popover>
        </td>
        <td>
          <p>{{ detail.drug.title }}</p>
          <p class="pack_comment" v-if="detail.drug.pack_comment">{{ detail.drug.pack_comment }}</p>
          <p class="pack_box_comment" v-if="detail.drug.pack_box_comment">{{ detail.drug.pack_box_comment }}</p>
          <p class="pack_box_comment" v-if="detail.drug.is_press_can"><span class="badge badge-danger">аэрозоль под давлением</span>
          </p>
          <template v-if="Object.keys(detail.extra_data?.orders_comments ?? {}).length">
            <p>Комментарии к заявкам</p>
            <div class="alert alert-info p-1 mb-1" v-for="(comments, orderId) in detail.extra_data.orders_comments">
              <p>заявка: <strong>{{ orderId }}</strong></p>
              <p v-for="c in comments">{{ c.text }}</p>
            </div>
          </template>
        </td>
        <td></td>
        <td>
          <input type="number" @change="silentUpdateQty(detail)" v-model="detail.income_qty" class="form-control">
        </td>
        <td>
          <button v-if="!hideEditDetails" class="btn btn-outline-info btn-sm mr-2" @click="openChangeDrugBlock(detail)"
                  type="button">
            <i class="icon-fa icon-fa-edit"/>
          </button>
          <strong>{{ printPackSet(detail.qty, detail.drug) }}</strong>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import ChangeQtyBlock from "@/components/invoices/ChangeQtyBlock";
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import api from "@/api";

export default {
  props: ['details', 'drugsImages', 'allowToEdit'],
  components: {
    ChangeQtyBlock,
    EmptyCardModal,
  },
  data() {
    return {
      hideEditDetails: true,
      modalChangeQtyData: null,
      localDetails: []
    }
  },
  mounted() {
    this.localDetails = [...this.details];
  },
  methods: {
    getSortedDetails() {
      return _.orderBy(this.details.filter((d) => +d.qty), 'drug.title')
    },
    openChangeDrugBlock(detail) {
      this.modalChangeQtyData = {
        header: 'Редактирование препарата',
        type: 'changeQty',
        drug: {...detail.drug, qty: +detail.qty}
      }
    },
    openCommentBlock(detail) {
      this.modalChangeQtyData = {
        header: 'Комментарий к препарату ' + detail.drug.title,
        acceptBtnText: 'Ok',
        detail: detail
      };
    },
    async silentUpdateQty(detail) {
      const {data} = await api.post('/invoices/updateByAction', {
        action: 'updateIncomeQty',
        detail
      })
      if (data.success) {

      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
    },
    updateChangeQty() {
      if (!this.$refs.changeBlock) {
        this.modalChangeQtyData = null;
        return;
      }
      const data = {...this.$refs.changeBlock.newData};
      if (!data.comment) {
        toastr['warning']('Требуется ввести комментарий');
        return;
      }
      if (data.new_qty < 0) {
        toastr['warning']('количество не может быть меньше 0');
        return;
      }

      const index = this.details.findIndex((d) => d.drug_id === this.modalChangeQtyData.drug.id);
      if (!this.details[index].comments) this.details[index].comments = [];
      this.details[index].comments.push({
        text: data.comment,
        changes: {
          old_qty: this.details[index].qty,
          new_qty: data.new_qty
        }
      });
      this.details[index].old_qty = this.details[index].qty;
      this.details[index].qty = data.new_qty;
      this.details[index].needUpdate = true;
      this.modalChangeQtyData = null;
    },
  }
}

</script>

<style scoped>
.pack_comment,
.pack_box_comment {
  font-size: 12px;
  color: #6c757d;
}

.comment {
  background-color: whitesmoke;
  padding: 3px 15px;
  margin-bottom: 2px;
}

.comment .text-muted {
  font-size: 12px;
}

.comment p {
  margin-bottom: 1px;
}

table.table td {
  padding: 3px 5px;
}

button {
  padding: 1px 10px !important;
}
</style>
